import React, { Component } from 'react';
import { NavLink } from 'react-router-dom'
import {connect} from "react-redux";
//Icon
import iconMaping from '../../../utils/IconMaping.js';
// import SideBarRow from '../../../asset/home/helper/SideRow.js'
// import RenderHelper from '../../../asset/home/helper/render.js'
import UserHelper from '../../../helper/user.js'
import PermissionProperties from '../../../config/permission.js'
// import MasterHelper from '../../../asset/home/helper/master.js'
import SelectQuery from '../../../component/SelectQuery.js'; 

class Sidebar extends Component {
  Master;
  constructor(props){
    super(props)
    // this.Master = new MasterHelper(this.props)
    this.state = {
      Asset       : '',
      Location    : '',
      User        : '',
      AssetID     : '',
      LocationID  : '',
      UserID      : '',
    }
  }

  handleClick(e) {
    e.preventDefault();
    e.target.parentElement.classList.toggle('open');
  }

  activeRoute(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1 ? 'nav-item nav-dropdown open' : 'nav-item nav-dropdown';
  }

  // secondLevelActive(routeName) {
  //   return this.props.location.pathname.indexOf(routeName) > -1 ? "nav nav-second-level collapse in" : "nav nav-second-level collapse";
  // }

  __HandleUserChanged__(val, param){
    var url_filter = '';
    if (val == null) {
        // filter null
    } else {
      if ( param === 'user' ) {
          localStorage.setItem('UserFilterID', val.value);
          localStorage.setItem('UserFilter', val.label);
          url_filter = '/admin/filter/user/'+ val.value + '/';
          localStorage.removeItem('LocationFilter');
          localStorage.removeItem('AssetFilter');
          window.location = window.location.origin + url_filter;

      } else if ( param === 'location' ) {
          localStorage.setItem('LocationFilterID', val.value);
          localStorage.setItem('LocationFilter', val.label);
          url_filter = '/admin/filter/location/'+ val.value + '/';
          localStorage.removeItem('UserFilter');
          localStorage.removeItem('AssetFilter');
          window.location = window.location.origin + url_filter;

      } else if ( param === 'asset' ) {
          localStorage.setItem('AssetFilterID', val.value);
          localStorage.setItem('AssetFilter', val.label);
          url_filter = '/admin/filter/asset/'+ val.value + '/';
          localStorage.removeItem('UserFilter');
          localStorage.removeItem('LocationFilter');
          window.location = window.location.origin + url_filter;
      } else {

      }
    }
  }

  FilterUser() {
    var get_local = localStorage.getItem('UserFilter');
    if ( get_local === undefined || get_local === null) {
        return 'Type user';
    } else {
      if (window.location.pathname === '/admin/all-activities' || window.location.pathname === '/admin/location') {
        return 'Type user';
      }
      else {
        return get_local;
      }
      // return;
    }
  }

  FilterLocation() {
    var get_local = localStorage.getItem('LocationFilter');
    if ( get_local === undefined || get_local === null) {
        return 'Type location';
    } else {
      if (window.location.pathname === '/admin/all-activities') {
        return 'Type location';
      }
      else {
        return get_local;
      }
      // return;
    }
  }

  FilterAsset() {
    var get_local = localStorage.getItem('AssetFilter');
    if ( get_local === undefined || get_local === null) {
        return 'Type asset';
    } else {
      if (window.location.pathname === '/admin/all-activities') {
        return 'Type asset';
      }
      else {
        return get_local;
      }
      // return;
    }
  }

  /* Option Value for react select */
  // option( filterParam ) {

  //   if ( filterParam === 'user' ) {
  //     var option_user = [];
  //     for ( var i = 0; i < this.props.UserModelReducer.rs.length; i++ ) {
  //       option_user.push (
  //         {value: this.props.UserModelReducer.rs[i].Alias, label: this.props.UserModelReducer.rs[i].FirstName+" "+this.props.UserModelReducer.rs[i].LastName},
  //       )
  //     }
  //     return option_user;

  //   } else if ( filterParam === 'location' ) {
  //     var option_location = [];
  //     for ( var j = 0; j < this.props.LocationReducer.rs.length; j++ ) {
  //       option_location.push (
  //         {value: this.props.LocationReducer.rs[j].Alias, label: this.props.LocationReducer.rs[j].Name},
  //       )
  //     }
  //     return option_location;

  //   } else if ( filterParam === 'asset' ) {
  //     var option_asset = [];
  //     for ( var k = 0; k < this.props.AssetReducer.rs.length; k++ ) {
  //       option_asset.push (
  //         {value: this.props.AssetReducer.rs[k].Alias, label: this.props.AssetReducer.rs[k].Name},
  //       )
  //     }
  //     return option_asset;

  //   } else {

  //   }

  // }

  // Render row User
  // __RenderSideRecordUser__(){

  //   if(this.props.UserModelReducer.rs == null){
  //     return
  //   }

  //   return(
  //     <div className="select-sidebar">
  //     <Select
  //       name="UserFilter"
  //       placeholder={this.FilterUser()}
  //       value={this.state.UserID}
  //       options={this.option('user')}
  //       onChange={(val)=>this.__HandleUserChanged__(val, 'user')}
  //     />
  //     </div>
  //   )
  // }


  // __RenderSideRecordLocation__(){
  //   if(this.props.LocationReducer.rs == null){
  //     return
  //   }

    // console.log(this.props.LocationReducer)

    // var jsx = []
    // for (var i = 0 ; i < this.props.LocationReducer.rs.length;i++){
    //   jsx.push(
    //       <SideBarRow Ref={"location"} Label={this.props.LocationReducer.rs[i].Name} Alias={this.props.LocationReducer.rs[i].Alias} />
    //   )
    // }
    // return jsx;

    // return(
    //   <div className="select-sidebar">
    //   <Select
    //     name="LocationFilter"
    //     placeholder={this.FilterLocation()}
    //     value={this.state.LocationID}
    //     options={this.option('location')}
    //     onChange={(val)=>this.__HandleUserChanged__(val, 'location')}
    //   />
    //   </div>
    // )
  // }

  // __RenderSideRecordAsset__(){

  //   if(this.props.AssetReducer.rs === null){
  //     return
  //   }

  //   return(
  //     <div className="select-sidebar">
  //     <Select
  //       name="AssetFilter"
  //       placeholder={this.FilterAsset()}
  //       value={this.state.AssetID}
  //       options={this.option('asset')}
  //       onChange={(val)=>this.__HandleUserChanged__(val, 'asset')}
  //     />
  //     </div>
  //   )

  // }

  sidebarMenuShow() {
    // e.preventDefault();
    document.body.classList.remove('sidebar-hidden');
  }

  sidebarMenuHide() {
    document.body.classList.add('sidebar-hidden');
  }

  render() {
    if (this.props.location.pathname.startsWith("/admin") || this.props.location.pathname.startsWith("/data-master") || this.props.location.pathname.startsWith('/su')){
      this.sidebarMenuShow();
    }else{
      this.sidebarMenuHide();
    }
    if (this.props.location.pathname.startsWith("/admin")){
      return (
        <div className="sidebar">
          <nav className="sidebar-nav">
            <ul className="nav">
              <li className="nav-title">Menu Admin
                <span className={"pull-right"} title="Go to Data master">
                  <NavLink to={"/data-master/tenant-setting"} className={"ic-master"}><i className="icon-settings"></i></NavLink>
                </span>
              </li>
              <li className={this.activeRoute("/admin/all-activities")}>
                <NavLink to={'/admin/all-activities'} className="nav-link" activeClassName=""><i className="icon-directions"></i> All Activities</NavLink>
              </li>
              <li className="nav-title">
                Filter By
              </li>
              <li className={this.activeRoute("/asset")}>
                <a role="button" tabIndex="0" className="nav-link nav-dropdown-toggle" onClick={this.handleClick.bind(this)}><i className={iconMaping.AVICON_DIAMOND}></i> Asset</a>
                <ul className="nav-dropdown-items">
                  <li className="nav-item">
                     <div className="select-sidebar">
                      <SelectQuery
                       name="Asset"
                       placeholder={this.FilterAsset()}
                       value={this.state.AssetID}
                       urlKey="read-asset-autocomplete"
                       valKey="Alias"
                       valLabel="Name"
                       onChange={(val)=>this.__HandleUserChanged__(val, 'asset')}
                       isCreatable={false}
                       UserReducer={this.props.UserReducer}
                      />
                    </div>
                  </li>
                </ul>
              </li>
              <li className={this.activeRoute("/location")}>
                <a role="button" tabIndex="0" className="nav-link nav-dropdown-toggle" onClick={this.handleClick.bind(this)}> <i className="icon-location-pin"></i> Location</a>
                <ul className="nav-dropdown-items">
                  <li className="nav-item">
                    {/*this.__RenderSideRecordLocation__()*/}
                    <div className="select-sidebar">
                      <SelectQuery
                       name="Location"
                       placeholder={this.FilterLocation()}
                       value={this.state.LocationID}
                       urlKey="read-location-autocomplete"
                       valKey="Alias"
                       valLabel="Name"
                       onChange={(val)=>this.__HandleUserChanged__(val, 'location')}
                       isCreatable={false}
                       UserReducer={this.props.UserReducer}
                      />
                    </div>
                  </li>
                </ul>
              </li>
              <li className={this.activeRoute("/user")}>
                <a role="button" tabIndex="0" className="nav-link nav-dropdown-toggle" onClick={this.handleClick.bind(this)}><i className="icon-people"></i> User</a>
                <ul className="nav-dropdown-items">
                  <li className="nav-item">
                     <div className="select-sidebar">
                      <SelectQuery
                       name="User"
                       placeholder={this.FilterUser()}
                       value={this.state.UserID}
                       urlKey="read-user-autocomplete"
                       valKey="Alias"
                       valLabel="Name"
                       onChange={(val)=>this.__HandleUserChanged__(val, 'user')}
                       isCreatable={false}
                       UserReducer={this.props.UserReducer}
                      />
                    </div>
                  </li>
                </ul>
              </li>
              <li className={"divider m-2"}></li>
              <li className={this.activeRoute("/asset/asset")}>
                <NavLink to={'/admin/master-asset'} className="nav-link" activeClassName="active"><i className={iconMaping.AVICON_DIAMOND}></i>Add/Edit Asset</NavLink>
              </li>
              <li className={this.activeRoute("/admin/job-stock-check")}>
                <NavLink to={'/admin/job-stock-check'} className="nav-link" activeClassName="active"><i className={iconMaping.AVICON_JOB}></i>Job Stock Check</NavLink>
              </li>
           {/*   <li className={this.activeRoute("/admin/locate-asset")}>
                <NavLink to={'/admin/locate-asset'} className="nav-link" activeClassName="active"><i className="icon-map"></i>Locate Asset</NavLink>
              </li>*/}
              <li className={this.activeRoute("/admin/booking")}>
                <NavLink to={'/admin/booking'} className="nav-link" activeClassName="active"><i className={iconMaping.AVICON_BOOKING}></i>Booking</NavLink>
              </li>
              <li className={this.activeRoute("/admin/request")}>
                <NavLink to={'/admin/request'} className="nav-link" activeClassName="active"><i className={iconMaping.AVICON_HOURGLASS}></i>Request</NavLink>
              </li>
              <li className={this.activeRoute("/admin/maintenance")}>
                <NavLink to={'/admin/maintenance'} className="nav-link" activeClassName="active"><i className={iconMaping.AVICON_MAINTENANCE}></i>Maintenance</NavLink>
              </li>
              {/*<li className={this.activeRoute("/admin/billing")}>
                <NavLink to={'/admin/billing'} className="nav-link" activeClassName="active"><i className={iconMaping.AVICON_BILLING}></i>Billing</NavLink>
              </li>*/}
            </ul>
          </nav>
        </div>
      )
    }else if (this.props.location.pathname.startsWith("/data-master")) {
      return (
        <div className="sidebar">
          <nav className="sidebar-nav">
            <ul className="nav">
              <li className="nav-title">
                Data Master
                <span className={"pull-right"} title="Back to admin page">
                  <NavLink to={"/admin/all-activities"} className={"ic-master"}><i className="icon-home"></i></NavLink>
                </span>
              </li>
              <li className={this.activeRoute("/location")}>
                <a role="button" tabIndex="0" className="auto-hide-icon nav-link nav-dropdown-toggle" onClick={this.handleClick.bind(this)}> <i className="auto-hide-icon icon-location-pin"></i> Location</a>
                <ul className="nav-dropdown-items">
                  <li className="nav-item">
                    <NavLink to={'/data-master/location/location'} className="nav-link" activeClassName="active"><i className="icon-location-pin"></i> Location</NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink to={'/data-master/location/site'} className="nav-link" activeClassName="active"><i className="icon-directions"></i> Site</NavLink>
                  </li>

                  {this.props.TenantReducer.coverage_city &&
                    <li className="nav-item">
                      <NavLink to={'/data-master/location/coverage'} className="nav-link" activeClassName="active"><i className="icon-map"></i> Coverage</NavLink>
                    </li>
                  }

                </ul>
              </li>
              <li className={this.activeRoute("/master")}>
                <a role="button" tabIndex="0" className="nav-link nav-dropdown-toggle" onClick={this.handleClick.bind(this)}><i className="auto-hide-icon icon-pin"></i> Master</a>
                <ul className="nav-dropdown-items">
                  <li className="nav-item">
                    <NavLink to={'/data-master/master/asset-status'} className="nav-link" activeClassName="active"><i className="icon-arrow-right"></i> Asset Status</NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink to={'/data-master/master/asset-type'} className="nav-link" activeClassName="active"><i className="icon-arrow-right"></i> Asset Type</NavLink>
                  </li>
                  {/*<li className="nav-item">
                    <NavLink to={'/data-master/master/business-model'} className="nav-link" activeClassName="active"><i className="icon-arrow-right"></i> Business Model</NavLink>
                  </li>*/}
                  <li className="nav-item">
                    <NavLink to={'/data-master/master/contact'} className="nav-link" activeClassName="active"><i className="icon-arrow-right"></i> Contact</NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink to={'/data-master/master/contractor'} className="nav-link" activeClassName="active"><i className="icon-arrow-right"></i> Contractor</NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink to={'/data-master/master/departement'} className="nav-link" activeClassName="active"><i className="icon-arrow-right"></i> Departement</NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink to={'/data-master/master/site-status'} className="nav-link" activeClassName="active"><i className="icon-arrow-right"></i> Site Status</NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink to={'/data-master/master/site-type'} className="nav-link" activeClassName="active"><i className="icon-arrow-right"></i> Site Type</NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink to={'/data-master/master/maintenance-type'} className="nav-link" activeClassName="active"><i className="icon-arrow-right"></i> Maintenance Type</NavLink>
                  </li>
                </ul>
              </li>
              <li className={this.activeRoute("/user")}>
                <a role="button" tabIndex="0" className="nav-link nav-dropdown-toggle" onClick={this.handleClick.bind(this)}><i className="auto-hide-icon icon-people"></i> User</a>
                <ul className="nav-dropdown-items">
                  <li className="nav-item">
                    <NavLink to={'/data-master/user/user'} className="nav-link" activeClassName="active"><i className="icon-people"></i> User</NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink to={'/data-master/user/role'} className="nav-link" activeClassName="active"><i className="icon-badge"></i> Role</NavLink>
                  </li>
                </ul>
              </li>
              <li className="nav-item">
                <NavLink to={'/data-master/tenant-setting'} className="nav-link" activeClassName="active"><i className="icon-settings"></i> Tenant Settings</NavLink>
              </li>
              <li className="nav-item">
                <NavLink to={'/data-master/import'} className="nav-link" activeClassName="active"><i className="icon-share-alt"></i> Import</NavLink>
              </li>
            </ul>
          </nav>
        </div>
      )
    }else if (this.props.location.pathname.startsWith("/asset")) {
      return (
        <div className="sidebar">
          <nav className="sidebar-nav">
            <ul className="nav">
              <li className="nav-title">
                Menu Asset
              </li>
            </ul>
          </nav>
        </div>
      )
    }else if (this.props.location.pathname.startsWith("/job")) {
      const renderNavLinkAddSite = () => {
        if(UserHelper.HasPermission(PermissionProperties.ASSET.ASSET.UPDATE,this.props.UserReducer)){
          return (
            <NavLink to={'/job/edit-site'} className="nav-link" activeClassName="active"><i className="icon-briefcase"></i> Add / Edit Site</NavLink>
          );
        }else{
          return null
        }

      };
      return (
        <div className="sidebar">
          <nav className="sidebar-nav">
            <ul className="nav">
              <li className="nav-title">
                Menu Job
              </li>
              <li className={this.activeRoute("/edit-site")}>
                {renderNavLinkAddSite()}
              </li>
            </ul>
          </nav>
        </div>
      )
    }else if (this.props.location.pathname.startsWith("/user")) {
      return (
        <div className="sidebar">
          <nav className="sidebar-nav">
            <ul className="nav">
              <li className="nav-title">
                Menu User
              </li>
            </ul>
          </nav>
        </div>
      )
    }else if (this.props.location.pathname.startsWith("/report")) {
      return (
        <div className="sidebar">
          <nav className="sidebar-nav">
            <ul className="nav">
              <li className="nav-title">
                Menu Reports
              </li>
              <li className={this.activeRoute("/request-report")}>
                <NavLink to={'/report/request-report'} className="nav-link" activeClassName="active"><i className="icon-printer"></i> Request Report</NavLink>
              </li>
            </ul>
          </nav>
        </div>
      )
    }else if (this.props.location.pathname.startsWith("/su")) {
      return (
        <div className="sidebar">
          <nav className="sidebar-nav">
            <ul className="nav">
              <li className="nav-title">
                Menu Superadmin
              </li>
{/*              <li className={this.activeRoute("/su/create-tenant")}>
                <NavLink to={'/su/create-tenant'} className="nav-link" activeClassName="active"><i className="icon-plus"></i> Create Tenant</NavLink>
              </li>*/}
              <li className={this.activeRoute("/su/tenant-list")}>
                <NavLink to={'/su/tenant-list'} className="nav-link" activeClassName="active"><i className=""></i> Tenant List</NavLink>
              </li>
              <li className={this.activeRoute("/su/business-model")}>
                <NavLink to={'/su/business-model'} className="nav-link" activeClassName="active"><i className=""></i> Bussines Model</NavLink>
              </li>
              <li className={this.activeRoute("/su/currency")}>
                <NavLink to={'/su/currency'} className="nav-link" activeClassName="active"><i className=""></i> Currency</NavLink>
              </li>
              <li className={this.activeRoute("/su/country")}>
                <NavLink to={'/su/country'} className="nav-link" activeClassName="active"><i className=""></i> Country</NavLink>
              </li>
              <li className={this.activeRoute("/su/province")}>
                <NavLink to={'/su/province'} className="nav-link" activeClassName="active"><i className=""></i> Province</NavLink>
              </li>
              <li className={this.activeRoute("/su/city")}>
                <NavLink to={'/su/city'} className="nav-link" activeClassName="active"><i className=""></i> City</NavLink>
              </li>
            </ul>
          </nav>
        </div>
      )
    }else {
      return (
        <div className="sidebar">
          <nav className="sidebar-nav">
            <ul className="nav">
              <li className="nav-title">
                Menu
              </li>
            </ul>
          </nav>
        </div>
      )
    }
  }
}

// export default Sidebar;
const mapStateToProps = (state) => {
  return {
      UserReducer: state.UserReducer,
      TenantReducer : state.TenantReducer,
      UserModelReducer : state.UserModelReducer,

      // Reducer: state.AssetReducer,
      // RequestReducer : state.RequestReducer,
      // LocationReducer : state.LocationReducer,
      // AssetReducer : state.AssetReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
    return {
        RunRedux: (data) => {
            dispatch(data);
        },
    };
};

// export default AssetScreen;
export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);



// WEBPACK FOOTER //
// ./src/App/views/components/Sidebar/Sidebar.js